import { useEffect } from "react";

const NO_ALIASES = {};

// Re-assert the scroll across a few frames so layout settling just after `ready` doesn't leave the
// target undershot.
const REASSERT_FRAMES = 8;

// Scroll to the `#<id>` section named by the URL hash once `ready` (the page's sections have mounted).
// The Source Directory cards deep-link to a section that mounts only after data loads, so the browser's
// native anchor jump misses it. `aliases` maps an incoming hash id to a different section id on this
// page (e.g. the PR hash carried to the expert page by the pr_profiles→experts redirect).
export default function useScrollToHashSection(ready, aliases = NO_ALIASES) {
  useEffect(() => {
    if (!ready || typeof document === "undefined") return undefined;

    const hashId = window.location.hash.slice(1);
    if (!hashId) return undefined;

    const target =
      document.getElementById(hashId) || (aliases[hashId] ? document.getElementById(aliases[hashId]) : null);
    if (!target || typeof target.scrollIntoView !== "function") return undefined;

    const scrollToTarget = () => {
      if (typeof target.scrollIntoView === "function") target.scrollIntoView({ behavior: "auto", block: "start" });
    };
    scrollToTarget();

    if (typeof window.requestAnimationFrame !== "function") return undefined;

    let rafId = null;
    let framesLeft = REASSERT_FRAMES;
    const reassert = () => {
      scrollToTarget();
      framesLeft -= 1;
      if (framesLeft > 0) rafId = window.requestAnimationFrame(reassert);
    };
    rafId = window.requestAnimationFrame(reassert);

    return () => {
      if (rafId != null) window.cancelAnimationFrame(rafId);
    };
  }, [ready, aliases]);
}
